import type { GradeShareData } from '../lib/types'
import { formatDate } from '../lib/format'
import { EvoLogoFull } from './icons'
import { Avatar } from './Avatar'
import styles from './report.module.css'

export function ReportHeader({ data }: { data: GradeShareData }) {
  return (
    <div className={styles.header}>
      <div className={styles.headerText}>
        <h1 className={styles.headerTitle}>
          AI grade report from{' '}
          <span className={styles.headerLogo}>
            <EvoLogoFull height={25} />
          </span>
        </h1>
        <p className={styles.gradedBy}>
          Graded on {formatDate(data.gradedAt)} by{' '}
          <Avatar
            pokemonId={data.user.pokemonId}
            profileColor={data.user.profileColor}
            username={data.user.username}
          />
          <span className={styles.gradedByName}>{data.user.username}</span>
        </p>
      </div>
    </div>
  )
}
